import React from "react";
import classNames from "classnames";
import "./style.scss";

export const Info = ({ children, className, textColor }) => {
  return (
    <div className={classNames("block-info", className)}>
      <p className="block-info-note-the-line-is">
        <span className={classNames("block-info-text-wrapper", textColor && `viso-text-${textColor}`)}>Note: </span>
        <span className={classNames("block-info-span", textColor && `viso-text-${textColor}`)}>
          {children}
        </span>
      </p>
    </div>
  );
};
